var _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800.00001 800.00001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 403.34,
    x2: 113.94,
    y1: 429.14,
    y2: 719.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    color: "#000000",
    colorRendering: "auto",
    fill: "#1c8adb",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.61 216.95-152.71 152.86h-26.564l-187.09 187.09c58.795 138.45 164.41 224.9 335 242.46l216.3-216.3v-213.24h-117.53l-44.76 44.775v-35.238l58.502-56.715-81.146-105.68z",
    color: "#000000",
    colorRendering: "auto",
    fill: "url(#c)",
    imageRendering: "auto",
    mask: "url(#a)",
    opacity: 0.42,
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.61 216.95-81.146 105.68h63.13c-0.51179 1.8086-0.85449 3.6847-0.85449 5.6614v130.21c0 11.5 9.2582 20.758 20.758 20.758 11.5 0 20.758-9.2582 20.758-20.758v-130.21c0-1.9766-0.3442-3.8528-0.85449-5.6614h59.356l-81.146-105.68zm-179.28 152.86v213.24h364.21v-213.24h-117.53v37.742h72.418v137.76h-273.99v-137.76h77.991v-37.742h-123.11z",
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    mask: "url(#b)",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d615ae95795d234808c0dd9d0fdd2aa0.svg";
export { ForwardRef as ReactComponent };